import abBasicTestingReducer from '@bridebook/web/app-basic/lib/ab-tests/ab-tests-slice';
import app from '@bridebook/web/app-basic/lib/app/app-slice';
import articles from '@bridebook/web/app-basic/lib/article/article-slice';
import searchBarInfo from '@bridebook/web/app-basic/lib/search/search-bar-info-slice';
import search from '@bridebook/web/app-basic/lib/search/search-slice';
import { AnalyticsService } from '@bridebook/web/app-basic/lib/services/analytics-service';
import supplierDetails from '@bridebook/web/app-basic/lib/supplier/supplier-details-slice';
import supplier from '@bridebook/web/app-basic/lib/supplier/supplier-slice';
import bbcommon from '@bridebook/web/app-basic/lib/bbcommon/bbcommon-slice';
import { BasicStore } from '@bridebook/web/app-basic/lib/types';
import { AnyAction, combineReducers, configureStore } from '@reduxjs/toolkit';
import { createWrapper, HYDRATE } from '@bridebook/web/app-shared/lib/next-redux-wrapper';

const analytics = null;

// @TODO - store creation requires typechecking
const combinedReducers = combineReducers({
  abTesting: abBasicTestingReducer,
  app,
  articles,
  search,
  supplier,
  bbcommon,
  supplierDetails,
  searchBarInfo,
});

const hydrate = (state: BasicStore, action: AnyAction): BasicStore => {
  const clientState: BasicStore = state;
  const serverState: BasicStore = action.payload;
  return {
    ...clientState,
    ...serverState,
    /**
     * Preserve the following properties on the client-side between routing
     */
    ...(clientState.abTesting.allTests && {
      abTesting: clientState.abTesting,
    }),
    ...(clientState.searchBarInfo.bounds && {
      searchBarInfo: clientState.searchBarInfo,
    }),
  };
};

const initStore = () => {
  const analyticsService = new AnalyticsService(analytics, {
    sessionId: null,
  });

  return configureStore({
    reducer: (state, action) => {
      if (state && action.type === HYDRATE) {
        return hydrate(state, action);
      }

      return combinedReducers(state, action);
    },
    devTools: {
      name: 'Bridebook Basic',
    },
    middleware: (getDefaultMiddleware) =>
      getDefaultMiddleware({
        thunk: {
          extraArgument: { analyticsService },
        },
      }),
  });
};

export type TBasicStore = ReturnType<typeof initStore>;

export const basicWrapper = createWrapper(initStore, { id: 'basic' });
